module.exports = __webpack_public_path__ + "static/media/question_inactive.12009fbc.svg";